import type { RefObject } from 'react';
import { BarCrumb } from './BarCrumb.js';
import { ThemeToggle } from './ThemeToggle.js';
import { AccountMenu } from './shell/AccountMenu.js';

interface ShellBarProps {
  onOpenDrawer: () => void;
  drawerTriggerRef: RefObject<HTMLButtonElement | null>;
  drawerOpen: boolean;
}

/**
 * Spec 229 — the bar. Breadcrumb left, tools right, hairline beneath.
 *
 * There is deliberately NO search pill and NO avatar here. The app has no
 * global search, and a pill that searches nothing is decorative chrome; the
 * signed-in person lives at the sidebar foot instead of appearing twice on
 * every screen. Gate 229.A.7 asserts both absences so they cannot regress.
 *
 * The drawer trigger is on the LEFT because the drawer slides in from the left.
 */
export function ShellBar({ onOpenDrawer, drawerTriggerRef, drawerOpen }: ShellBarProps) {
  return (
    <header className="hub-shell__bar" data-testid="shell-bar">
      <div className="flex items-center gap-3 min-w-0">
        <button
          ref={drawerTriggerRef}
          type="button"
          className="hub-round hub-compact-only"
          aria-label="Open navigation"
          aria-expanded={drawerOpen}
          data-testid="drawer-trigger"
          onClick={onOpenDrawer}
        >
          <i className="bx bx-menu" aria-hidden="true" />
        </button>
        <BarCrumb />
      </div>
      {/* Spec 247 — Kridt: round tools, then the person's disc last. The disc
          opens the account menu (settings, theme, sign out). */}
      <div className="hub-shell__tools">
        <ThemeToggle />
        <AccountMenu />
      </div>
    </header>
  );
}
